// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"2706":"939aba47","3091":"939aba47","4966":"939aba47","5472":"939aba47","8153":"939aba47"}[chunkId] + ".chunk.css";
};